import type { ConfiguredImageProviders } from '@nuxt/image'

/** Claves válidas para `NuxtImg`/`provider`, según `nuxt.config` → `image.providers`. */
export type NuxtConfiguredImageProvider = keyof ConfiguredImageProviders

/** Datos CMS (`provider` como string) → tipo que espera `NuxtImg`. */
export function asNuxtImageProvider(
  provider: string | undefined | null
): NuxtConfiguredImageProvider | undefined {
  if (provider == null || provider === '') return undefined
  return provider as NuxtConfiguredImageProvider
}
